import React from "react";
import { cn } from "../../lib/utils";

interface RainbowButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const RainbowButton = React.forwardRef<
  HTMLButtonElement,
  RainbowButtonProps
>(({ children, className, ...props }, ref) => {
  // Base styles for the button
  const baseStyles = [
    "group",
    "relative",
    "inline-flex",
    "h-11",
    "animate-rainbow",
    "cursor-pointer",
    "items-center",
    "justify-center",
    "rounded-xl",
    "border-0",
    "bg-[length:200%]",
    "px-8",
    "py-2",
    "font-medium",
    "text-primary-foreground",
    "transition-colors",
    "[background-clip:padding-box,border-box,border-box]",
    "[background-origin:border-box]",
    "[border:calc(0.18*1rem)_solid_transparent]",
    "focus-visible:outline-none",
    "focus-visible:ring-1",
    "focus-visible:ring-ring",
    "disabled:pointer-events-none",
    "disabled:opacity-50",
  ];

  // Before pseudo-element styles
  const beforeStyles = [
    "before:absolute",
    "before:bottom-[-20%]",
    "before:left-1/2",
    "before:z-0",
    "before:h-1/5",
    "before:w-3/5",
    "before:-translate-x-1/2",
    "before:animate-rainbow",
    "before:bg-[linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",
    "before:bg-[length:200%]",
    "before:[filter:blur(calc(0.6*1rem))]",
  ];

  // Light mode styles
  const lightModeStyles = [
    "bg-[linear-gradient(#121213,#121213),linear-gradient(#121213_50%,rgba(18,18,19,0.6)_80%,rgba(18,18,19,0)),linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",
  ];

  // Dark mode styles
  const darkModeStyles = [
    "dark:bg-[linear-gradient(#fff,#fff),linear-gradient(#fff_50%,rgba(255,255,255,0.6)_80%,rgba(0,0,0,0)),linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",
  ];

  return (
    <a 
    href="https://www.swebench.com/#verified" // Replace with your desired link
    target="_blank" 
    rel="noopener noreferrer" // Prevent security vulnerabilities
    >    
    <button
      ref={ref}
      className={cn(
        ...baseStyles,
        ...beforeStyles,
        ...lightModeStyles,
        ...darkModeStyles,
        className, // Include any additional className passed as a prop
      )}
      {...props}
      
    >
      {children}
      {/* Icon */}

      <svg
        width="14"
        height="14"
        className="ml-2"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.78141 5.33312L5.20541 1.75712L6.14808 0.814453L11.3334 5.99979L6.14808 11.1851L5.20541 10.2425L8.78141 6.66645H0.666748V5.33312H8.78141Z"
          fill="#FFFFFF" // White icon
          className="text-white"
        />
      </svg>

    </button>
    </a>
  );
});

RainbowButton.displayName = "RainbowButton";